export const filterSeparator = ",";
export const filterCompoundSeparator = ",";
